/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */

import React, { useEffect, useState, useRef } from 'react';
import { useLanguage } from '@components/common/locale/useLanguage';
import { _ } from '@evershop/evershop/src/lib/locale/translate';
import ProductPicksMobile from './components/productPicks/ProductPicksMobile';
import { extractDescriptionText } from './utils/categoryHelpers';
import { useProductModal } from './components/productModal/useProductModal';
import ProductModal from './components/productModal/ProductModal';

// Shuffle array function
var shuffleArray = array => {
  var shuffled = [...array];
  for (var i = shuffled.length - 1; i > 0; i -= 1) {
    var j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};
export default function RandomizedProductPicksMobile(_ref) {
  var {
    collections,
    shoppingCartTitle,
    storeStatus
  } = _ref;
  var {
    isAr
  } = useLanguage();
  var [products, setProducts] = useState([]);
  var [currentIndex, setCurrentIndex] = useState(0);
  var scrollContainerRef = useRef(null);

  /* ── Modal state ── */
  var {
    isOpen,
    product: modalProduct,
    openModal,
    closeModal
  } = useProductModal();
  var touchStartRef = useRef(0);
  var touchEndRef = useRef(0);

  // Update products data
  useEffect(() => {
    var _collection$products3;
    var requiredCode = shoppingCartTitle ? 'menuc-01' : 'menuf-01';
    var collection = collections === null || collections === void 0 ? void 0 : collections.find(col => col.code === requiredCode);
    if (shoppingCartTitle) {
      var _collection$products;
      // For "YOU MIGHT LIKE THESE!" section - show 10 products
      if ((collection === null || collection === void 0 || (_collection$products = collection.products) === null || _collection$products === void 0 || (_collection$products = _collection$products.items) === null || _collection$products === void 0 ? void 0 : _collection$products.length) > 10) {
        setProducts(shuffleArray(collection.products.items).slice(0, 10));
      } else {
        var _collection$products2;
        setProducts((collection === null || collection === void 0 || (_collection$products2 = collection.products) === null || _collection$products2 === void 0 ? void 0 : _collection$products2.items) || []);
      }
    } else if ((collection === null || collection === void 0 || (_collection$products3 = collection.products) === null || _collection$products3 === void 0 || (_collection$products3 = _collection$products3.items) === null || _collection$products3 === void 0 ? void 0 : _collection$products3.length) <= 4) {
      var _collection$products4;
      setProducts((collection === null || collection === void 0 || (_collection$products4 = collection.products) === null || _collection$products4 === void 0 ? void 0 : _collection$products4.items) || []);
    } else if (collection) {
      setProducts(shuffleArray(collection.products.items).slice(0, 4));
    }
  }, [collections, shoppingCartTitle]);

  // Handle button click - Open Modal
  var handleButtonClick = product => {
    var _product$image, _product$image2, _product$price;
    if (storeStatus === '0') return;
    openModal({
      productId: product.productId,
      image: ((_product$image = product.image) === null || _product$image === void 0 ? void 0 : _product$image.single) || ((_product$image2 = product.image) === null || _product$image2 === void 0 ? void 0 : _product$image2.url) || '',
      name: isAr ? product.nameAr || product.name : product.name,
      description: extractDescriptionText(isAr ? product.descriptionAr || product.description : product.description),
      price: Number((_product$price = product.price) === null || _product$price === void 0 || (_product$price = _product$price.regular) === null || _product$price === void 0 ? void 0 : _product$price.value) || 0,
      currency: 'EGP',
      url: product.url || "/product/".concat(product.url_key)
    });
  };

  // Carousel navigation functions
  var scrollToIndex = index => {
    if (scrollContainerRef.current) {
      var container = scrollContainerRef.current;
      var scrollAmount = container.scrollWidth / products.length;
      container.scrollTo({
        left: isAr ? -scrollAmount * index : scrollAmount * index,
        behavior: 'smooth'
      });
      setCurrentIndex(index);
    }
  };
  var handlePrevious = () => {
    var newIndex = Math.max(0, currentIndex - 1);
    scrollToIndex(newIndex);
  };
  var handleNext = () => {
    var maxIndex = Math.max(0, products.length - 1);
    var newIndex = Math.min(maxIndex, currentIndex + 1);
    scrollToIndex(newIndex);
  };

  // Touch handlers for swipe
  var handleTouchStart = e => {
    touchStartRef.current = e.touches[0].clientX;
  };
  var handleTouchMove = e => {
    touchEndRef.current = e.touches[0].clientX;
  };
  var handleTouchEnd = () => {
    if (!touchStartRef.current || !touchEndRef.current) return;
    var diff = touchStartRef.current - touchEndRef.current;
    var minSwipeDistance = 50;
    if (Math.abs(diff) > minSwipeDistance) {
      if (isAr) {
        // In RTL, diff > 0 means swiped towards left (which is previous)
        if (diff > 0) {
          handlePrevious();
        } else {
          handleNext();
        }
      } else {
        // In LTR
        if (diff > 0) {
          handleNext();
        } else {
          handlePrevious();
        }
      }
    }
    touchStartRef.current = 0;
    touchEndRef.current = 0;
  };
  var canGoPrevious = currentIndex > 0;
  var canGoNext = currentIndex < products.length - 1;
  return (products === null || products === void 0 ? void 0 : products.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "random-picks-container md:hidden"
  }, shoppingCartTitle ? /*#__PURE__*/React.createElement("div", {
    className: "mb-6 mt-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "category-header flex items-center justify-center gap-4"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-left text-[#C60910] uppercase font-zoom-pro-normal text-[1.4rem] "
  }, _('Items to Pair With'), "! \uD83E\uDD29"), /*#__PURE__*/React.createElement("div", null))) : /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-4 mb-8 max-w-[40rem] ml-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-[0.8rem] bg-primary w-[2.1rem] flex-shrink-0"
  }), /*#__PURE__*/React.createElement("h3", {
    className: "text-[#0E0F0B] font-[500] font-zoom-pro-compact uppercase text-[1.6rem] whitespace-nowrap"
  }, _('Items to Pair With'), "! \uD83E\uDD29"), /*#__PURE__*/React.createElement("div", {
    className: "h-[0.8rem] bg-primary flex-grow"
  })), shoppingCartTitle && products.length > 2 ?
  /*#__PURE__*/
  // Swipeable carousel for "YOU MIGHT LIKE THESE!"
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: scrollContainerRef,
    dir: isAr ? 'rtl' : 'ltr',
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd,
    className: "overflow-x-hidden scroll-smooth",
    style: {
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      WebkitOverflowScrolling: 'touch'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-[1.9rem] ".concat(shoppingCartTitle ? "pt-[4rem]" : "pt-[6rem]")
  }, products.map(product => {
    var _product$customizatio, _product$category, _product$category2, _product$category3;
    var priceText = product.price && product.price.regular ? product.price.regular.value : '';
    var imageUrl = product.image ? product.image.single : '';
    var isCustomizable = !!((_product$customizatio = product.customizationGroups) !== null && _product$customizatio !== void 0 && _product$customizatio.length);
    return /*#__PURE__*/React.createElement("div", {
      key: product.ProductId,
      className: "flex-shrink-0 w-[47%]"
    }, /*#__PURE__*/React.createElement(ProductPicksMobile, {
      storeStatus: storeStatus,
      image: imageUrl,
      category: isAr ? ((_product$category = product.category) === null || _product$category === void 0 ? void 0 : _product$category.nameAr) || ((_product$category2 = product.category) === null || _product$category2 === void 0 ? void 0 : _product$category2.name) : (_product$category3 = product.category) === null || _product$category3 === void 0 ? void 0 : _product$category3.name,
      name: isAr ? product.nameAr || product.name : product.name,
      isSpicy: product.isSpicy,
      description: extractDescriptionText(isAr ? product.descriptionAr || product.description : product.description),
      isNewItem: product === null || product === void 0 ? void 0 : product.new_item,
      price: priceText,
      url: product.url || "/product/".concat(product.url_key),
      stockAvailability: product.stock_status !== 'OUT_OF_STOCK',
      onAddToCart: () => handleButtonClick(product),
      isCustomizable: isCustomizable
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center gap-4 mb-4 mt-6"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handlePrevious,
    disabled: !canGoPrevious,
    className: "w-11 h-11 rounded-full rotate-180 flex items-center justify-center transition-all rtl:rotate-0  ".concat(canGoPrevious ? 'opacity-100 ' : 'opacity-100'),
    "aria-label": "Previous products"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0307 12.531L9.53068 20.031C9.46099 20.1007 9.37827 20.156 9.28722 20.1937C9.19618 20.2314 9.0986 20.2508 9.00005 20.2508C8.9015 20.2508 8.80392 20.2314 8.71288 20.1937C8.62183 20.156 8.53911 20.1007 8.46943 20.031C8.39974 19.9614 8.34447 19.8786 8.30676 19.7876C8.26904 19.6965 8.24963 19.599 8.24963 19.5004C8.24963 19.4019 8.26904 19.3043 8.30676 19.2132C8.34447 19.1222 8.39974 19.0395 8.46943 18.9698L15.4397 12.0004L8.46943 5.03104C8.32869 4.89031 8.24963 4.69944 8.24963 4.50042C8.24963 4.30139 8.32869 4.11052 8.46943 3.96979C8.61016 3.82906 8.80103 3.75 9.00005 3.75C9.19907 3.75 9.38995 3.82906 9.53068 3.96979L17.0307 11.4698C17.1004 11.5394 17.1557 11.6222 17.1935 11.7132C17.2312 11.8043 17.2506 11.9019 17.2506 12.0004C17.2506 12.099 17.2312 12.1966 17.1935 12.2876C17.1557 12.3787 17.1004 12.4614 17.0307 12.531Z",
    fill: canGoPrevious ? '#C60910' : '#858585'
  }))), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleNext,
    disabled: !canGoNext,
    className: "w-11 h-11 rounded-full  flex items-center justify-center transition-all rtl:rotate-180 ".concat(canGoNext ? 'opacity-100 ' : 'opacity-100'),
    "aria-label": "Next products"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0307 12.531L9.53068 20.031C9.46099 20.1007 9.37827 20.156 9.28722 20.1937C9.19618 20.2314 9.0986 20.2508 9.00005 20.2508C8.9015 20.2508 8.80392 20.2314 8.71288 20.1937C8.62183 20.156 8.53911 20.1007 8.46943 20.031C8.39974 19.9614 8.34447 19.8786 8.30676 19.7876C8.26904 19.6965 8.24963 19.599 8.24963 19.5004C8.24963 19.4019 8.26904 19.3043 8.30676 19.2132C8.34447 19.1222 8.39974 19.0395 8.46943 18.9698L15.4397 12.0004L8.46943 5.03104C8.32869 4.89031 8.24963 4.69944 8.24963 4.50042C8.24963 4.30139 8.32869 4.11052 8.46943 3.96979C8.61016 3.82906 8.80103 3.75 9.00005 3.75C9.19907 3.75 9.38995 3.82906 9.53068 3.96979L17.0307 11.4698C17.1004 11.5394 17.1557 11.6222 17.1935 11.7132C17.2312 11.8043 17.2506 11.9019 17.2506 12.0004C17.2506 12.099 17.2312 12.1966 17.1935 12.2876C17.1557 12.3787 17.1004 12.4614 17.0307 12.531Z",
    fill: canGoNext ? '#C60910' : '#858585'
  }))))) :
  /*#__PURE__*/
  // Grid view for "ALL-TIME FAVORITES"
  React.createElement("div", {
    className: "grid mt-[5rem] grid-cols-2 gap-x-[1.9rem] gap-y-[8rem] justify-center px-4 ".concat(shoppingCartTitle ? 'gap-x-[2.5rem] ml-[-1rem]' : '', " ")
  }, products.map(product => {
    var _product$customizatio2, _product$category4, _product$category5, _product$category6;
    var priceText = product.price && product.price.regular ? product.price.regular.value : '';
    var imageUrl = product.image ? product.image.single : '';
    var isCustomizable = !!((_product$customizatio2 = product.customizationGroups) !== null && _product$customizatio2 !== void 0 && _product$customizatio2.length);
    return /*#__PURE__*/React.createElement(ProductPicksMobile, {
      storeStatus: storeStatus,
      key: product.ProductId,
      image: imageUrl,
      category: isAr ? ((_product$category4 = product.category) === null || _product$category4 === void 0 ? void 0 : _product$category4.nameAr) || ((_product$category5 = product.category) === null || _product$category5 === void 0 ? void 0 : _product$category5.name) : (_product$category6 = product.category) === null || _product$category6 === void 0 ? void 0 : _product$category6.name,
      name: isAr ? product.nameAr || product.name : product.name,
      isSpicy: product.isSpicy,
      description: extractDescriptionText(isAr ? product.descriptionAr || product.description : product.description),
      isNewItem: product === null || product === void 0 ? void 0 : product.new_item,
      price: priceText,
      url: product.url || "/product/".concat(product.url_key),
      stockAvailability: product.stock_status !== 'OUT_OF_STOCK',
      onAddToCart: () => handleButtonClick(product),
      isCustomizable: isCustomizable
    });
  })), /*#__PURE__*/React.createElement(ProductModal, {
    isOpen: isOpen,
    product: modalProduct,
    onClose: closeModal,
    storeStatus: storeStatus
  }));
}